import { useEffect, useState } from 'react';

// read synchronously so the first render already matches the screen
export const useMediaQuery = (query: string): boolean => {
  const [ matches, setMatches ] = useState(() => window.matchMedia(query).matches);

  useEffect(() => {
    const mediaQuery = window.matchMedia(query);
    const handler = (event: MediaQueryListEvent) => setMatches(event.matches);

    'addEventListener' in mediaQuery
      ? mediaQuery.addEventListener('change', handler)
      : (mediaQuery as MediaQueryList).addListener(handler);
    setMatches(mediaQuery.matches);

    return () => {
      'addEventListener' in mediaQuery
        ? mediaQuery.removeEventListener('change', handler)
        : (mediaQuery as MediaQueryList).removeListener(handler);
    };
  }, [ query ]);

  return matches;
};
